import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";
import {Http, Response} from "@angular/http";

@Component({
  selector: 'app-current-batch-transactions',
  templateUrl: './current-batch-transactions.component.html',
  styleUrls: ['./current-batch-transactions.component.css'],
  providers: [DiamondPayDataService],
})
export class CurrentBatchTransactionsComponent implements OnInit {
    private collection: any[];
    private process_in_progress: boolean;

  constructor(private dataService: DiamondPayDataService, private _http: Http) { }

  ngOnInit() {
      this.process_in_progress = false;
      this.dataService
            .retrieveCurrentBatchTransactions()
            .subscribe((data:any[]) => this.collection = data, error => console.log(error));
  }

  public ProcessBatch(transactions) {
    this.process_in_progress = true;
    if (!confirm('Are you sure?')) return ;
    var transaction_ids = transactions.map(transaction => transaction.id);
    this.dataService.
            processQueuedTransactions(transaction_ids).
            subscribe(data => location.reload(true), error => console.log(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/current-batch-transactions/current-batch-transactions.component.ts